<template>
  <div class="Institute">
    <v-container grid-list-md fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md8>
          <v-card class="mb-2">
            <v-card-title class="title">
              Reporte por Institución
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    :data="dataVals"
                    :name="'Reporte por Institución.csv'"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headers"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableWithTotals'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'Institute',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadTable()
  },

  data: function () {
    return {
      backConf: {
        path: '/semcali/rp_inst',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,

      headers: [
        {
          text: 'Institución',
          align: 'left',
          value: 'institucion',
          str: 'Totales'
        },
        { text: 'Total Encuestas', value: 'total' }
      ],
      labels: {
        institucion: 'Institución',
        total: 'Total Encuestas'
      },

      dataVals: null,
      tableKey: 0
    }
  },

  computed: {},

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          // operativo: this.operativo,
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loading = false
          t.tableKey += 1
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
